import React from 'react';

export default function Loading({ fullScreen = false, color = 'var(--u-accent, #F5A623)' }) {
  const wrapperStyle = fullScreen
    ? {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, #fffdf9 0%, #faf8f5 100%)',
      }
    : {
        padding: '48px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };

  return (
    <div style={wrapperStyle}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: '50%',
            border: '4px solid rgba(139, 111, 71, 0.16)',
            borderTopColor: color,
            animation: 'blogSpin 0.85s linear infinite',
          }}
        />
        <span style={{ fontSize: 14, color: '#6F5838', fontWeight: 600 }}>
          Loading articles...
        </span>
      </div>
      <style>{`@keyframes blogSpin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
